<a
    class="sidebar__brand"
    routerLink="/"
    aria-label="Независимая оценка качества услуг — на главную"
>
    <img class="sidebar__logo" src="logo.svg" alt="" width="40" height="46" />
    <span class="sidebar__title">Сервис независимой оценки качества оказания услуг</span>
</a>
<app-shell-controls
    [collapsed]="collapsed()"
    [userName]="userName()"
    [roleName]="roleName()"
    (navToggled)="navToggled.emit()"
    (logoutRequested)="logoutRequested.emit()"
/>

@if (createAction(); as create) {
    <a
        class="sidebar__create"
        [routerLink]="create.path"
        queryParamsHandling="preserve"
        [attr.aria-label]="create.label"
        [matTooltip]="create.label"
        [matTooltipDisabled]="!collapsed()"
        matTooltipPosition="right"
        *appHasRole="['administrator']"
    >
        <app-nav-icon name="create" class="sidebar__create-icon" />
        <span class="sidebar__create-label">{{ create.label }}</span>
    </a>
}

@if (primary(); as primary) {
    <a
        class="sidebar__primary"
        [routerLink]="primary.path"
        [attr.aria-label]="primary.label"
        [matTooltip]="primary.label"
        [matTooltipDisabled]="!collapsed()"
        matTooltipPosition="right"
    >
        <app-nav-icon [name]="primary.icon" class="sidebar__primary-icon" />
        <span class="sidebar__primary-label">{{ primary.label }}</span>
    </a>
}

<app-sidebar-nav [collapsed]="collapsed()" />
